module.exports = __webpack_public_path__ + "f061636b1b06d8d2b188ba6793e7dbb7.svg";